import { useLocale } from '@/i18n/locale-context';
import { Button, Input } from '@/components/ui';
import { PageHeader, Placeholder, Section } from './page-parts';

/**
 * `/:locale/newsletter` — PRD §16, Phase 13.
 *
 * The form is real markup rather than a skeleton because it has no data to wait for; what
 * Phase 13 adds is the submit handler, the double opt-in round trip and the confirmation
 * states. Submitting today does nothing, which is why the button is disabled.
 */
export default function NewsletterPage() {
  const { t } = useLocale();
  return (
    <Placeholder phase="13">
      <PageHeader title={t('newsletter.title')} subtitle={t('newsletter.body')} />
      <Section>
        <form className="flex max-w-md flex-col gap-3" onSubmit={(event) => event.preventDefault()}>
          <Input
            label={t('newsletter.placeholder')}
            labelHidden
            type="email"
            name="email"
            autoComplete="email"
            placeholder={t('newsletter.placeholder')}
          />
          <Button type="submit" disabled>
            {t('newsletter.submit')}
          </Button>
        </form>
      </Section>
    </Placeholder>
  );
}
